﻿var vm;

(function () {
    'use strict';

    var controllerId = 'inspectionTime';

    angular.module('app.controllers').controller(controllerId, inspectionTime)

    inspectionTime.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams', '$translate'];

    function inspectionTime(common, datacontext, $http, $scope, $stateParams, $translate) {
        vm = this;

        vm.carrierId = 0;
        vm.carrierName = "";
        vm.carrierFilterDisabled = false;

        vm.validFamilies = ['DRY', 'REF'];
        vm.gateInMovements = ['CD', 'PD', 'RE', 'FA', 'DD', 'TR'];
        vm.defaultGateInMovements = ['CD', 'TR'];

        function init() {
            common.activateController().then(function (data) { });
            vm.clearCriteria();
            vm.initializeControls();
            vm.setBasicInformation();
            vm.getPresentationTypes();
            vm.getGeneralFilters();
            vm.getCarriers();
            vm.clearReport();
        }

        vm.initializeControls = function () {
            vm.reportTitle = $translate.instant('views.inspectiontime.title');
            vm.xaxistitle = $translate.instant('views.inspectiontime.xaxistitle');
            vm.yaxistitledays = $translate.instant('views.inspectiontime.yaxistitle.days');
            vm.yaxistitleweeks = $translate.instant('views.inspectiontime.yaxistitle.weeks');

            $('#txtDateFrom').datepicker({
                format: 'dd/mm/yyyy'
            });
            $('#txtDateTo').datepicker({
                format: 'dd/mm/yyyy'
            });
        }

        vm.setBasicInformation = function () {
            var authData = common.localStorageService.get('authorizationData');
            vm.roleSelected = authData ? authData.userRole : "";
            vm.isAdmin = vm.roleSelected === "COPAdminP" ? true : false;

            var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');

            if (associateCarrier && associateCarrier.Name) {
                vm.carrierId = associateCarrier.BusinessPartnerId;
                vm.carrierName = associateCarrier.Name;
            }
        }

        vm.updateCarrierFilter = function () {
            if (vm.listCarriers && vm.carrierId !== 0) {
                vm.listCarriers.forEach(function (value, key) {
                    if (value.id == vm.carrierId) {
                        vm.criteria.carrierIds = [value];
                        vm.carrierFilterDisabled = true;
                    }
                });
            }
            else {
                vm.carrierFilterDisabled = false;
            }
        }

        vm.initializeListPresentationTypes = function () {
            vm.presentationTypes = [];
            vm.criteria.presentationType = null;
        };

        vm.getPresentationTypes = function () {
            vm.initializeListPresentationTypes();
            return datacontext.inspectiontime.getDateTypes().then(function (data) {
                if (data != null) {
                    angular.forEach(data, function (value, key) {
                        vm.presentationTypes.push(value);
                    });
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        vm.initializeDepot = function () {
            vm.listDepots = [];
        };

        vm.initializeListMovementType = function () {
            vm.listMovementTypes = [];
        };

        vm.initializeFamily = function () {
            vm.listFamilies = [];
        };
        vm.fnSetDefaultDepot = function() {
            var authData = common.localStorageService.get('authorizationData');
            if (authData) {
                var currentYardId = authData.ModelRequester.CurrentYardId;
                if (currentYardId !== undefined)
                    vm.criteria.depotId = Number(currentYardId);
            }
        }

        vm.getGeneralFilters = function () {
            vm.initializeDepot();
            vm.initializeListMovementType();
            vm.initializeFamily();

            return datacontext.inspectiontime.getFilters(vm.roleSelected).then(function (data) {
                if (data) {
                    if (data.MovementType != null && data.MovementType.length > 0) {
                        angular.forEach(data.MovementType, function (movementType, key) {
                            if (vm.gateInMovements.indexOf(movementType.Code) != -1) {
                                vm.listMovementTypes.push({ id: movementType.Id, label: movementType.Name, code: movementType.Code });
                            }
                        });
                        vm.setDefaultMovementTypes();
                    }

                    if (data.FamilyList != null && data.FamilyList.length > 0) {
                        angular.forEach(data.FamilyList, function (family, key) {
                            if (vm.validFamilies.indexOf(family.Code) != -1) {
                                vm.listFamilies.push({ id: family.Id, label: family.Name });
                            }
                        });
                    }

                    if (data.Depot != null && data.Depot.length > 0) {
                        vm.listDepots = data.Depot;
                        vm.criteria.depotId = vm.listDepots[0].Id;
                        vm.fnSetDefaultDepot();
                    }
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.initializeCarrier = function () {
            vm.listCarriers = [];
        };

        vm.getCarriers = function () {
            vm.initializeCarrier();
            return datacontext.inspectiontime.getCarrierList().then(function (data) {
                if (data) {
                    angular.forEach(data, function (value, key) {
                        vm.listCarriers.push({ id: value.Id, label: value.Name });
                    });
                    vm.updateCarrierFilter();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };
        vm.startDat = function () {
            $('#txtDateFrom').focus();
        }

        vm.endDat = function () {
            $('#txtDateTo').focus();
        }

        vm.setDefaultMovementTypes = function () {
            vm.criteria.movementTypeIds = vm.GetObectsFromMultiSelectList(vm.defaultGateInMovements);
        }

        vm.GetObectsFromMultiSelectList = function (defaultItems) {
            var selectedObjects = [];
            angular.forEach(defaultItems, function (val, key) {
                angular.forEach(vm.listMovementTypes, function (movement, key) {
                    if (val == movement.code) selectedObjects.push(movement);
                });
            });
            return selectedObjects;
        }

        vm.clearReport = function () {
            vm.clearCriteria();

            vm.series = [];

            vm.valueAxis = {
                max: 5,
                title: { text: vm.xaxistitle },
                line: {
                    visible: false
                },
                minorGridLines: {
                    visible: true
                },
                labels: {
                    rotation: "auto",
                    format: "{0}"
                },
                axisCrossingValue: -10
            };

            vm.categoryAxis = {
                categories: [],
                title: { text: "" },
                majorGridLines: {
                    visible: false
                },
                labels: {
                    rotation: 315,
                    font: "10px Arial,Helvetica,sans-serif"
                }
            };

            vm.tooltip = {
                visible: true,
                template: "#= series.name #: #= parseFloat(value).toFixed(2) #"
            }

            vm.refresReport();
        };

        vm.clearCriteria = function () {
            vm.criteria = {
                depotId: vm.listDepots ? (vm.listDepots.length > 0 ? vm.listDepots[0].Id : 0) : 0,
                familyIds: [],
                movementTypeIds: [],
                carrierIds: [],
                presentationType: "Week",
                dateFrom: null,
                dateTo: null
            };

            vm.setDefaultMovementTypes();
        }

        vm.searchReport = function () {
            var valid = true;

            if (vm.criteria.dateTo == null || vm.criteria.dateTo == undefined || vm.criteria.dateTo == "") {
                toastr.info($translate.instant('views.inspectiontime.fieldDateTo'));
                valid = false;
            }

            if (vm.criteria.dateFrom == null || vm.criteria.dateFrom == undefined || vm.criteria.dateFrom == "") {
                toastr.info($translate.instant('views.inspectiontime.fieldDateFrom'));
                valid = false;
            }

            if (!valid)
                return;

            var criteria = {
                depotId: vm.criteria.depotId,
                familyIds: vm.GetIdsFromMultiSelectList(vm.criteria.familyIds),
                movementTypeIds: vm.GetIdsFromMultiSelectList(vm.criteria.movementTypeIds),
                carrierIds: vm.GetIdsFromMultiSelectList(vm.criteria.carrierIds),
                presentationType: vm.criteria.presentationType,
                dateFrom: vm.criteria.dateFrom ? vm.fnConvertDateToSQLFormat(vm.criteria.dateFrom) : null,
                dateTo: vm.criteria.dateTo ? vm.fnConvertDateToSQLFormat(vm.criteria.dateTo) : null
            };

            datacontext.inspectiontime.getInspectionTimeList(criteria).then(function (data) {
                if (data.Result === 1) {
                    if (data) {
                        var hasSeries = data.series.length > 0;
                        vm.valueAxis.max = hasSeries ? data.max : 5;
                        vm.valueAxis.title = hasSeries ? { text: vm.xaxistitle } : null;
                        vm.categoryAxis.categories = hasSeries ? data.categories : [];
                        vm.categoryAxis.title = hasSeries ? { text: vm.criteria.presentationType == "Week" ? vm.yaxistitleweeks : vm.yaxistitledays } : null;
                        vm.series = hasSeries ? data.series : [];
                        vm.refresReport();
                    }
                }
                else {
                    vm.clearReport();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.GetIdsFromMultiSelectList = function (selectedItems) {
            var ids = [];
            angular.forEach(selectedItems, function (val, key) { ids.push(val.id); });
            return ids;
        }

        vm.refresReport = function () {
            var mainReport = angular.element('#mainReport').data("kendo-chart");

            if (mainReport) {
                mainReport.options.series = vm.series;
                mainReport.options.valueAxis = vm.valueAxis;
                mainReport.options.valueAxis.labels = { format: "{0}" };
                mainReport.options.categoryAxis = vm.categoryAxis;
                mainReport.refresh();
            }
        }

        vm.fnConvertDateToSQLFormat = function (date) {
            var parseDate = null;
            if (date != undefined && date != '') {
                var splitDate = date.split("/");
                parseDate = splitDate[1] + '/' + splitDate[0] + '/' + splitDate[2];
            }
            return parseDate;
        }

        init();
    }

})();
